/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, MouseEvent } from "react";
import { Badge, Button, IconButton, Stack, Tooltip } from "@mui/material";
import {
  FolderZip,
  //PriorityHigh,
  FileDownload,
  //Edit,
  Tune as TuneIcon,
} from "@mui/icons-material";

import { DateRangeField } from "../../../../App/app/common/date-picker";
import { CustomTableToolbar } from "../../../../App/app/common/custom-table";
import { useAppDispatch } from "../../../../_config/react/useAppDispatch";
import { useSelector } from "react-redux";
import { RootState } from "../../../../_config/redux";
import {
  updateDate,
} from "../../../Domain/Application/avoir.slice";
//import DropDownButton from "../../../../App/app/common/DropDownButton";
import {
  exportToXLSX,
  dateFormat
} from "../../../../App/app/common/_helpers";
import { EntityId } from "@reduxjs/toolkit";
import { getZipOfAllDocumentsOfFacture } from "../../../../App/infra/api/facture.api-service";
import { setError } from "../../../../App/core/notification/notification.slice";
//import { ClientFournisseurRadioSelect } from "../ClientFournisseurRadioSelect";
import { selectAllFactures, selectAvoir } from "../../../Domain/Application/selectors";
import { format } from 'date-fns';
import AvoirSearchPopover from "./avoir-filters/AvoirSearchPopover";
//import { Link } from 'react-router-dom';
interface Props {
  selectedRows: EntityId[];
  /*selectedType: "fournisseur" | "client" | "";
  filterType: (type: "fournisseur" | "client" | "") => void;*/
}

function AvoirTableToolbar({
  selectedRows,
 /* filterType,
  selectedType,*/
}: Props) {


   
  const dispatch = useAppDispatch();
  const selectedDates = useSelector((state: RootState) => state.avoirs.dates);
  const [filtersFactureBadge, setfiltersFactureBadge] = useState(0);
  const filters: any = useSelector((state: RootState) => state.avoirs.filters);
  const [isSearchPopoverOpen, setIsSearchPopoverOpen] = useState(false);
  const [searchAnchorEl, setSearchAnchorEl] = useState<Element | null>(null);

  const onDateUpdate = (field: string, value: string) => {
    if (value !== selectedDates) dispatch(updateDate(value));
  };



  const downloadZipFileForSelection = async () => {
    try {
      const zips = await Promise.all(
        selectedRows.map((id) => getZipOfAllDocumentsOfFacture(id))
      );
      zips.forEach((zip) => {
        const url = window.URL.createObjectURL(zip);
        window.open(url); //, '_blank')
      });
    } catch (e) {
      dispatch(
        setError({
          message: "un problème est survenu lors de l'export du fichier Zip",
        })
      );
    }
  };


  //const onChangeFilter = (selected: string) => dispatch(updateStatus(selected));
  const factures = useSelector(selectAllFactures);
  const avoirs = useSelector(selectAvoir);
/*
  const getStatusOfFactures = (status: string) => {
    switch (status) {
      case "CREATED":
        return "Nouvelle facture";
      case "EMITTED":
        return "Facture émise";
      case "EDITED":
        return "Facture éditée";
      case "PAID":
        return "Facture payée";
      case "CANCELLED":
        return "Facture annulée";
      case "ARCHIVE":
        return "Facture archivée";
      default:
        return null;
    }
  };
*/

  const onClickExport = () => {
    
    const excelLine = avoirs.map((avoir) => {

      return {
        numero : avoir.numero,
        numeroFacture : avoir.ref_facture.numeroFacture,
        date : new Date(avoir.created_at).toLocaleDateString('fr-FR'),
        client : avoir.ref_facture.client.name,
        montantFactureTTc : Number(avoir.ref_facture.totalTTC).toFixed(2) + " €",
        montantAvoirTTC: Number(avoir.net_a_deduire.value).toFixed(2) + " €",
        differentiel: (Number(avoir.ref_facture.totalTTC)-Number(avoir.net_a_deduire.value)).toFixed(2) + " €",
        consommeLe: avoir.used_at ? new Date(avoir.used_at).toLocaleDateString('fr-FR') : '',
        parFacturenumero : factures.find((f) => f.id === avoir.facture_number)?.numeroFacture,
        numeroEncaissement: '',
      };
    });
    const heading = [
      "N° Avoir",
      "N° Facture",
      "Date",
      "Client",
      "Total Facture TTC",
      "Total Avoir TTC",
      "Différentiel",
      "Consommé le",
      "Par Facture N°",
      "N° Encaissement",
    ];
    /*
    
        const excelLine = toExport.map((factures) => {
      return {
        numero: factures.numeroFacture,
        status: getStatusOfFactures(factures.status),
        date: factures.dateDeFacturation,
        client: factures.client.name,
        clientType: factures.type,
        nbLignes: factures.bons?.length,
        totalFraisAuto: factures.totalFraisAutoroute,
        totalTva: factures.totalTva,
        totalTTC: factures.totalTTC,
        totalEncaisse: factures.reglement.montant,
      };
    });
    
    const heading = [
      "N° Facture",
      "Status",
      "Date",
      "Client",
      "Type client",
      "Nb Lignes",
      "Total Frais Auto",
      "total TVA",
      "Total TTC",
      "Total Encaissé",
    ]; */
    let export_dates = format(new Date(), dateFormat);
    if(selectedDates !== "") {
      export_dates = selectedDates;
    }
    exportToXLSX(excelLine, `Avoirs-${export_dates}`, heading);
  };

  useEffect(() => {
    let badgeCounter = 0;
    for (const property in filters) {
        if ( filters[property] !== '' && filters[property] !== 0) {
            badgeCounter++;
        }
    }
    setfiltersFactureBadge(badgeCounter);
}, [filters]);

  const onOpenSearchPopover = (event: MouseEvent) => {
    const { currentTarget } = event;
    setIsSearchPopoverOpen(true);
    setSearchAnchorEl(currentTarget);
  };
  const onCloseSearchPopover = () => {
    setIsSearchPopoverOpen(false);
    setSearchAnchorEl(null);
};


  return (
    <>
      <CustomTableToolbar>
        <Stack direction="row" alignItems="flex-end" spacing={1}>
          <DateRangeField
            sx={{ width: 270 }}
            size="small"
            variant="outlined"
            label="Filtrer par date..."
            onDateUpdate={onDateUpdate}
            value={selectedDates}
          />

          {/* Buttons */}
          <Tooltip title="Filtrer">
            <IconButton onClick={onOpenSearchPopover}>
              <Badge badgeContent={filtersFactureBadge} color="error">
                  <TuneIcon/>
              </Badge>
            </IconButton>
          </Tooltip>

          {/*<ClientFournisseurRadioSelect
            onChange={(e) => filterType(e.target.value as any)}
            selectedValue={selectedType}
          />*/}

          {/* Buttons 
          
          <DropDownButton
            labels={[
              { label: "Toutes les factures", value: "" },
              ...factureStatus,
            ]}
            onChange={onChangeFilter}
          />

           <Button
            size="small"
            variant="contained"
            color="warning"
            startIcon={<PriorityHigh />}
            onClick={handleRelanceDialog}
          >
            Relances
          </Button>
        
          <Button 
            component={Link} 
            size="small"
            to="ecriture" 
            variant="contained" 
            color="secondary" 
            startIcon={<Edit/>}>
                    Ecritures
          </Button>
          
          */}

          <Button
            size="small"
            variant="contained"
            color="info"
            startIcon={<FolderZip />}
            onClick={downloadZipFileForSelection}
            disabled={selectedRows.length === 0}
          >
            Zip
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={onClickExport}
            startIcon={<FileDownload />}
            size="small"
          >
            XLSX
          </Button>
        </Stack>
        {/*<Stack>*/}
        {/*</Stack>*/}

      </CustomTableToolbar>

      {/* Dialogs */}


      <AvoirSearchPopover
                open={isSearchPopoverOpen}
                anchorEl={searchAnchorEl}
                onCloseSearchPopover={onCloseSearchPopover}
                type={""}
            />

    </>
  );
}

export default AvoirTableToolbar;
